<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row">
      <vx-card v-show="!treeview">
        <vs-table
          :max-items="descriptionItems[1]"
          pagination
          :description="false"
          :data="entities"
          search
          @selected="handleSelected"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("entity.label.business_entity") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-git-branch"
                type="border"
                @click="$router.push({ name: 'Business Entity Tree View' })"
                size="small"
                >{{ $t("entity.label.tree_view") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-activity"
                type="border"
                @click="
                  $router.push({ name: 'Business Entity Transaction History' })
                "
                size="small"
                >{{ $t("entity.label.activity_log") }}</vs-button
              >
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Entity' })"
                size="small"
                >{{ $t("entity.label.create_business_entity") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("entity.label.business_entity_name") }}</vs-th>
            <!-- <vs-th>{{ $t("entity.label.business_entity_code") }}</vs-th> -->
            <vs-th>{{ $t("entity.label.parent_business_entity") }}</vs-th>
            <vs-th>{{ $t("entity.label.business_entity_type") }}</vs-th>
            <vs-th>{{ $t("entity.label.opened_on") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("entity.label.actions") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="entity" v-for="(entity, index) in data">
              <vs-td :data="entity.name">{{ entity.name }}</vs-td>
              <!-- <vs-td :data="entity.externalId">{{ entity.externalId }}</vs-td> -->
              <vs-td :data="entity.parentName">{{ entity.parentName }}</vs-td>
              <vs-td :data="entity.officeType">{{ entity.officeType }}</vs-td>
              <vs-td :data="getDate(entity.openingDate)">{{
                getDate(entity.openingDate)
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    :title="$t('entity.label.Edit')"
                    icon="EditIcon"
                    class="icon_row"
                    @click.stop="editData(entity.id)"
                    svgClasses="w-5 h-5 stroke-current orange_icon"
                  />
                  <img
                    class="h-5 w-5 icon_row"
                    src="@/assets/images/icons/Credit.png"
                    :title="$t('entity.label.UpdateCredit')"
                    @click.stop="updateCraditModel(entity.id)"
                    alt="Update Credit"
                  />

                  <img
                    class="h-5 w-5 icon_row"
                    src="@/assets/images/icons/AddTicket.png"
                    :title="$t('entity.label.AddTicket')"
                    @click.stop="showTicketForm(entity.id)"
                    alt="Add Ticket"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>

      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('entity.label.credit')"
          :active.sync="updateCraditPopup"
          class="popup-close"
        >
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full w-full">
                <vs-input
                  :label="$t('entity.label.credit_limit')"
                  type="text"
                  class="w-full font-semibold"
                  v-model="credit.creditLimitAmount"
                />
              </div>
            </div>

            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button
                  icon-pack="feather"
                  type="border"
                  icon="icon-x"
                  @click="clearCredit"
                  >{{ $t("entity.label.clear") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button
                  icon-pack="feather"
                  icon="icon-check"
                  @click="updateCreditLimit"
                  >{{ $t("entity.label.submit") }}</vs-button
                >
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('entity.label.new_ticket')"
        :active.sync="ticketPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer">
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.priority")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.priority')"
                    :key="resetKey"
                  >
                    <v-select
                      label="value"
                      :options="ticketTemplates.priorityType"
                      :placeholder="$t('entity.label.SelectPriority')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.priority"
                      :reduce="(value) => value.value"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.ticket_date')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('entity.label.ticket_date')"
                    class="w-full font-semibold"
                    readonly
                    v-model="ticket.ticketDate"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.category")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.category')"
                    :key="resetKey"
                  >
                    <v-select
                      label="mCodeValue"
                      :options="ticketTemplates.problemsDatas"
                      :placeholder="$t('entity.label.SelectCategory')"
                      :reduce="(mCodeValue) => mCodeValue.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.problemCode"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.mCodeValue
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.sub_category")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.sub_category')"
                    :key="resetKey"
                  >
                    <v-select
                      label="subCategory"
                      :options="subCategoryItem"
                      :placeholder="$t('entity.label.SelectSubCategory')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.subCategory"
                      :reduce="(subCategory) => subCategory.subCategory"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.assign_to")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.assign_to')"
                    :key="resetKey"
                  >
                    <v-select
                      label="userName"
                      :options="ticketTemplates.usersData"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="ticket.assignedTo"
                      :reduce="(userName) => userName.id"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.source")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.source')"
                    :key="resetKey"
                  >
                    <v-select
                      label="mCodeValue"
                      :options="ticketTemplates.sourceData"
                      :placeholder="$t('entity.label.SelectSource')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                      :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                      v-model="ticket.sourceOfTicket"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.due_time")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.due_time')"
                    :key="resetKey"
                  >
                    <flat-pickr
                      :config="configdateTimePicker"
                      class="w-full mb-2"
                      v-model="ticket.dueTime"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('entity.label.title')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('entity.label.title')"
                    v-model="ticket.title"
                    class="w-full font-semibold mb-2 starlabel"
                    icon-no-border
                    :danger="false"
                    danger-text="wrong input"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("entity.label.description")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('entity.label.description')"
                    :key="resetKey"
                  >
                    <vs-textarea class="w-full" v-model="ticket.description" />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                <vs-upload
                  id="file"
                  text="File"
                  limit="1"
                  ref="file"
                  :show-upload-button="true"
                  class="compose-mail-attachment"
                  @change="changeDocument"
                />
              </div>
            </div>

            <div style="height: 30px"></div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="addTicket"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("entity.label.submit") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </ValidationObserver>
        <validation-popup
          :errorMessage="errorMessage"
          :warningPopup="warningPopup"
          :warningText="warningText"
          @closeWarning="warningPopup = false"
        ></validation-popup>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { AddTicket } from "@/assets/images/icons/AddTicket.png";
import moment from "moment";
import { VTree, VSelectTree } from "vue-tree-halower";
import { AtomSpinner } from "epic-spinners";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { setHeader, removeHeader } from "@/http";
import { mapState } from "vuex";
const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  title: "",
  type: "Office",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: null,
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
};
export default {
  data() {
    return {
      loading: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      searchOption: 0,
      treeview: false,
      resetKey: 0,
      ticketPopup: false,
      ticket: ticketObj,
      descriptionItems: [5, 10, 15],
      updateCraditPopup: false,
      credit: {
        creditLimitAmount: "",
        id: "",
      },
      entityId: 0,
      initSelected: ["node-1"],
      treeData: [
        {
          title: "node1",
          expanded: false,
          async: true,
        },
      ],
      bulkUploads: {
        file: null,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
      },
    };
  },
  components: {
    VTree,
    VSelectTree,
    AddTicket,
    Datepicker,
    AtomSpinner,
    flatPickr,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      entities: (state) => state.entity.list,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      ticketCreated: (state) => state.entity.createTicketResponse,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),

    entityTemplate() {
      return this.$store.getters["entity/template"];
    },
    ticketTemplates() {
      return this.$store.getters["entity/getTicketTemplate"];
    },
  },
  watch: {
    ticketPopup(newValue) {
      if (newValue) {
        this.ticketTemplate();
        this.ticket.ticketDate = moment().format("DD MMMM YYYY");
        this.ticket.ticketTime = moment().format("hh:mm:ss A");
      } else {
        this.ticket = {
          dueTime: null,
          assignedTo: null,
          priority: null,
          sourceOfTicket: null,
          problemCode: null,
          subCategory: null,
          description: null,
          title: "",
          type: "Office",
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          ticketDate: null,
          ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
          ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
          ticketTime: null,
        };
      }
    },
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    handleSelected(item) {
      this.$router.push({
        name: "View Business Entity",
        params: { id: item.id },
      });
    },
    changeDocument() {
      this.bulkUploads.file = document.getElementById("file").files[0];
    },
    async ticketTemplate() {
      try {
        this.$store.dispatch("entity/setTicketTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getEntityList() {
      try {
        this.loading = true;
        await this.$store.dispatch("entity/setEntities", {});
        this.loading = false;
      } catch (e) {
        console.log("something went to wrong while entities:", e);
      }
    },
    async getSubCategory(categoryId) {
      try {
        this.$store.dispatch("entity/setTicketSubcategory", categoryId);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addTicket() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        let ticketData = {
          priority: this.ticket.priority,
          sourceOfTicket: this.ticket.sourceOfTicket,
          problemCode: this.ticket.problemCode,
          assignedTo: this.ticket.assignedTo,
          title: this.ticket.title,
          description: this.ticket.description,
          subCategory: this.ticket.subCategory,
          locale: "en",
          dateFormat: "dd MMMM yyyy",
          ticketDate: this.ticket.ticketDate,
          ticketURL: `${this.ticket.ticketURL2}${this.entityId}`,
          ticketTime: " " + this.ticket.ticketTime,
          type: this.ticket.type,
        };
        // ticketURL: `https://smartway.trigital.in/app/#/viewTicket/${this.entityId}`,
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        formData.append("name", this.ticket.title);
        formData.append("description", this.ticket.description);
        formData.append("file", this.bulkUploads.file);

        removeHeader("Content-Type");

        await this.$store.dispatch("entity/createTicketAction", {
          id: this.entityId,
          data: ticketData,
        });

        if (this.ticketCreated) {
          this.$toasted.success("Ticket generated successfully");
          formData.append("childEntityId", this.ticketCreated);
          this.$store.dispatch("entity/createTicketDocAction", {
            id: this.entityId,
            data: formData,
          });

          this.ticketPopup = false;
          this.cancel();
        }
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    nodechecked(node, v) {
      alert("that a node-check envent ..." + node.title + v);
    },
    editData(id) {
      this.$router.push({ name: "Edit Business Entity", params: { id: id } });
    },
    updateCraditModel(id) {
      this.updateCraditPopup = true;
      if (this.updateCraditPopup) {
        this.credit.id = id;
      }
    },
    showTicketForm(id) {
      this.resetKey++;
      this.ticketPopup = true;
      this.entityId = id;
      this.ticketTemplate();
      this.active = true;
    },
    async updateCreditLimit() {
      const credit = {
        locale: "en",
        creditLimitAmount: this.credit.creditLimitAmount,
      };
      try {
        await this.$store.dispatch("entity/setUpdateCreditLimit", {
          id: this.credit.id,
          credit: credit,
        });
        //const resp = await updateCreditLimit(this.credit.id, credit);

        this.updateCraditPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Credit Limit Done Successfully!",
          type: "success",
          confirmButtonText: "VIEW",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push({
              name: "View Business Entity",
              params: { id: this.credit.id },
            });
          }
        });
      } catch (e) {
        console.log("something went to wrong while credit limit:", e);
      }
    },
    clearCredit() {
      this.credit.creditLimitAmount = "";
      this.updateCraditPopup = false;
    },
  },
  mounted() {
    this.getEntityList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
